/** Central image paths — files served from public/assets at runtime */

export const logo = '/assets/torbit-logo.png'

export const heroImages = {
  default: '/assets/hero.png',
  factory: '/assets/hero-factory.png',
  slide1: '/assets/hero-slide-1.png',
  slide2: '/assets/hero-slide-2.png',
  slide3: '/assets/hero-slide-3.png',
}

export const homeImages = {
  productsSectionBg: '/assets/cta-section-bg.png',
}

export const aboutImages = {
  heroPort: '/assets/about-hero-port.png',
  companyFacility: '/assets/about-company-facility.png',
  missionBackground: '/assets/products-hero-metals.png',
  visionPort: '/assets/about-vision-port.png',
  whyCollage: '/assets/about-why-collage.png',
}

export const contactImages = {
  hero: '/assets/contact-hero-bg.png',
  ctaGlobalLogistics: '/assets/contact-cta-global-logistics.png',
}

export const leadershipImages = {
  hero: '/assets/leadership-hero-bg.png',
  vision: '/assets/leadership-vision.png',
}

export const productsImages = {
  heroMetals: '/assets/products-hero-metals.png',
  ctaCoils: '/assets/products-cta-coils.png',
}

export const servicesImages = {
  heroContainers: '/assets/services-hero-containers.png',
  globalCollage: '/assets/services-global-collage.png',
  ctaChess: '/assets/services-cta-chess.png',
}

export const achievementsImages = {
  hero: '/assets/achievements-hero-bg.png',
}

export const productImages = {
  aluminium: '/assets/products/aluminium.png',
  brass: '/assets/products/brass.png',
  copper: '/assets/products/copper.png',
  lead: '/assets/products/lead.png',
  stainlessSteel: '/assets/products/stainless-steel.png',
  zinc: '/assets/products/zinc.png',
  ingots: '/assets/product-metal-ingots.svg',
  scrap: '/assets/product-industrial-scrap.svg',
}
